export default __webpack_public_path__ + "static/media/volcanobetBg.d852bae6.png";